<template>
  <audio
    :src="src"
    controls="controls"
    controlslist="nodownload"
  ></audio>
</template>

<script>
export default {
  name: 'VAudio',
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
audio {
  width: 100%;
  height: 33px;
  border: 1px solid #d7d7d7;
  border-radius: 16px;
  background-color: #f2f3f4;
}
</style>